module.exports = new __parcel__URL__("COVID-19_EUA_80777-291-80_Paperboard_Carton.39e72da0.jpg").toString();